import { writable } from 'svelte/store';
import type { EditorAttrs } from './editor.type';

const editorSchema: EditorAttrs = {
	delta: '',
	html: '',
	text: ''
};

export const editorStore = writable<EditorAttrs>(editorSchema);
